module.exports = __webpack_public_path__ + "img/dfd186f.png";